// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Rba-z","fadeIn":"Sba-z","delay":"Tba-z","recommendedSizeTooltip":"Uba-z"};